import ImpureChessTermsAndConditions from '../components/Docs/ImpureChessTermsAndConditions.js';
import Page from '../components/Page/Page.js';

function ImpureChessTermsAndConditionsPage()
{
    return(
        <Page mainSection={<ImpureChessTermsAndConditions />} />
    );
}

export default ImpureChessTermsAndConditionsPage;